import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`

export const Map = styled.div`
  flex: 1.5;
`

export const ContainerTimeline = styled.div`
  flex: 0.5;
  background: #f9f9f9;
  border-radius: 10px;
  padding: 20px;
  height: 450px;
  overflow-y: scroll;
  border: 1px solid #cccccc;
`
